<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Ses deux papas</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">Par Ariel Tachna</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Srikkanth Bhattacharya est le célibataire gay par excellence et parfaitement heureux de l’être, jusqu’à ce qu’il reçoive un appel de l’hôpital local lui annonçant que sa meilleure amie est morte en couches. Sri avait accepté de donner son sperme afin que le rêve de maternité de Jill se réalise, mais il ne s’était pas attendu à être responsable d’une petite fille. Il décide de la placer dans une famille adoptive, mais une fois qu’il la voit, Sri ne peut se résoudre à le faire, et se débat maintenant pour apprendre à s’occuper d’un nouveau-né.</p>
<p class="P_Normal">Son colocataire et ami, Jaime Frias, propose de l’aider, ne se doutant pas qu’il allait tomber amoureux du bébé et de Sri. Tout semble parfait jusqu’à ce qu’une visite des Services Sociaux plonge Sri dans le désarroi, lui donnant l’impression qu’il doit choisir entre sa fille et une relation avec l’homme qu’il était venu à aimer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?f44fd836